import { memo } from 'react'
import Head from 'next/head'
import PropTypes from 'prop-types'

const BreadCrumb = memo((props) => {
  const { className, breadcrumb, breadcrumbHead, addHead } = props

  if (!breadcrumb || !breadcrumb.length) return null

  return (
    <>
      {addHead && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbHead) }}
          />
        </Head>
      )}
      <div className="container breadcrumbContainer">
        <div className={`breadcrumb ${className}`}>
          <ol data-test="breadcrumb">
            {breadcrumb?.map((item, index) => {
              return (
                <li data-test="item" key={index}>
                  {item?.url ? (
                    <a data-test="link" href={item?.url}>
                      {item?.text}
                    </a>
                  ) : (
                    <span data-test="current-page">{item?.text}</span>
                  )}
                </li>
              )
            })}
          </ol>
        </div>
      </div>
      <style jsx global>{`
        //breadcrumb css module yapilinca contracts, cities, towns vb sayfalarda menu calismiyor
        .breadcrumbContainer {
          .breadcrumb {
            overflow: hidden;
            margin-bottom: 14px;
            ol {
              white-space: nowrap;
              list-style: none;
              padding: 0;
              margin: 0;
              overflow: hidden;

              li {
                display: inline;
                font-size: 12px;
                color: #666;

                + li:before {
                  font-size: 14px;
                  font-family: 'io-icons';
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: inherit;
                  -webkit-font-smoothing: antialiased;
                  content: '\e924';
                  padding: 0 12px 0 13px;
                  vertical-align: -1px;
                  color: #333;
                }
                a {
                  color: #333;
                  text-decoration: none;
                  font-size: 12px;

                  &:hover,
                  &:focus {
                    color: #1298e6;
                  }
                }
              }
            }

            &.v2, &.v4 {
              padding-top: 17px;
              padding-bottom: 31px;
              margin-top: 0;
              margin-bottom: 0;
            }
            &.v1 {
              padding-bottom: 14px;
              margin-top: 0;
              margin-bottom: 0;
            }
            @media (max-width: 992px) {
              height: 35px;
              background: #f4f4f8;
              margin-bottom: 0;
              scrollbar-width: none; /* Firefox */
              -ms-overflow-style: none; /* IE 10+ */
              &::-webkit-scrollbar {
                display: none; /* Chrome/Safari/Webkit */
                width: 0;
              }
              ol {
                white-space: nowrap;
                overflow-x: scroll;
                margin-left: 6px;
                min-height: 40px;
              }

              &.v5 {
                background-color: initial;
                padding: 0 10px;
              }

              &.v4 {
                padding: 16px 0px 10px 17px;
                margin-bottom: 24px;
                background-color: initial;
                ol {
                  direction: unset;
                  margin-left: 0;
                }
              }


              &.v3 {
                padding: 12px 15px 10px 0;
                ol {
                  margin-left: 17px;
                }
              }

              &.v2 {
                padding: 10px 0px 10px 17px;
                margin-bottom: 14px;
                ol {
                  direction: unset;
                  margin-left: 0;
                }
              }

              &.v1 {
                margin-left: -14px;
                margin-right: -14px;
                padding: 8px 15px 8px 22px;
                margin-top: 34px; //68-51 = 17px
                border-top: #d8d8d8 1px solid;
                border-bottom: solid 0.5px #d8d8d8;
                background: #fff;
              }
            }
            @media (max-width: 768px) {
              &.v1 {
                margin-left: 0;
                margin-right: 0;
                padding-left: 10px;
              }
            }
          }

          @media (max-width: 992px) {
            padding: 0;
            overflow: hidden;
          }
        }

      `}</style>
    </>
  )
})

BreadCrumb.propTypes = {
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  className: PropTypes.string,
}

BreadCrumb.defaultProps = {
  breadcrumb: [],
  className: '',
}

export default BreadCrumb
